var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 141,
    viewBox: "0 0 141 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.735 19.7838C116.681 18.7811 115.126 18.3053 113.597 18.8576L21.8002 50.9676C20.7848 51.5072 19.7949 53.0749 19.8331 54.6172C19.8713 56.1594 20.9377 57.6762 21.9786 58.1648L64.5921 75.6272L84.1438 117.323C84.6962 118.853 86.2511 119.329 87.7934 119.291C89.3357 119.252 90.8524 118.186 91.3283 116.631L118.852 23.3569C119.341 22.316 118.788 20.7865 117.735 19.7838ZM34.2402 54.7745L101.552 30.9873L67.4601 66.8113C66.9587 67.3381 66.9587 67.3381 66.9715 67.8522L34.2402 54.7745ZM86.9226 104.909L72.2525 73.3797C72.7665 73.367 72.7538 72.8529 73.2679 72.8402L107.359 37.0161L86.9226 104.909Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.db728c2350696a4cb86aea5a147ff491.svg";
export { ForwardRef as ReactComponent };